import { withNamespaces } from "react-i18next"
import Accordion from 'react-bootstrap/Accordion';
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { RiBuilding2Fill } from "react-icons/ri";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';

const CompanyIdentification = ({
    t,
    activeAccordion,
    setActiveAccordion,

    detailsQuery
}) => {
    if (detailsQuery.isFetching) {
        return (
            <Row>
                <Col 
                    sm="12" 
                    className="mt-4 mb-4"
                >
                    <div 
                        className="dt-field dt-skeleton" 
                        style={{ width: '100%', height: '100px' }}
                    />
                </Col>
            </Row>
        )
    }

    const dateUtils = new DateUtils();

    const organizationData = JSON.parse(detailsQuery.data?.company?.organizationData || "");

    const { basic_information, activity_classifications } = organizationData?.company_identification || {};

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('company-identification')}
            className={activeAccordion === 'company-identification' ? 'active' : ''}
            eventKey={'company-identification'}
        >
            <Accordion.Header>
                <RiBuilding2Fill size="24" className="me-2" />

                <span>
                    {t('Company Identification')}
                </span>
            </Accordion.Header>

            <Accordion.Body>
                {/* Basic Information */}
                <h5 className="fw-bold font-size-16">
                    {t('Basic Information')}
                </h5>
                <Table striped bordered hover size="sm">
                    <tbody>
                        <tr>
                            <th>{t('Registered Company Name')}</th>
                            <td>{basic_information.registered_company_name}</td>
                        </tr>
                        <tr>
                            <th>{t('Business Name')}</th>
                            <td>{basic_information.business_name}</td>
                        </tr>
                        <tr>
                            <th>{t('Legal Form Description')}</th>
                            <td>{basic_information.legal_form?.description}</td>
                        </tr>
                        <tr>
                            <th>{t('Company Status')}</th>
                            <td>
                                {basic_information.company_status?.status} - {basic_information.company_status?.description}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('Company Registration Number')}</th>
                            <td>{basic_information.company_registration_number}</td>
                        </tr>
                        <tr>
                            <th>{t('VAT Registration Number')}</th>
                            <td>{basic_information.vat_registration_number}</td>
                        </tr>
                        <tr>
                            <th>{t('Date of Company Registration')}</th>
                            <td>
                                {dateUtils.convertDateToDate(basic_information.dateof_company_registration, INTERNATIONAL_DATE_FORMAT)}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('Date of Starting Operations')}</th>
                            <td>
                                {dateUtils.convertDateToDate(basic_information.dateof_starting_operations, INTERNATIONAL_DATE_FORMAT)}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('Country')}</th>
                            <td>{basic_information.country}</td>
                        </tr>
                        <tr>
                            <th>{t('Principal Activity')}</th>
                            <td>{basic_information.principal_activity?.description} ({basic_information.principal_activity?.code})</td>
                        </tr>
                    </tbody>
                </Table>


                {/* Contact Information */}
                <h5 className="fw-bold font-size-16">
                    {t('Headquarters / Contact Address')}
                </h5>
                <Table striped bordered hover size="sm">
                    <tbody>
                        <tr>
                            <th>{t('Full Address')}</th>
                            <td>{basic_information.contact_address?.full_address}</td>
                        </tr>
                        <tr>
                            <th>{t('Street')}</th>
                            <td>{basic_information.contact_address?.street}</td>
                        </tr>
                        <tr>
                            <th>{t('City')}</th>
                            <td>{basic_information.contact_address?.city}</td>
                        </tr>
                        <tr>
                            <th>{t('Postal Code')}</th>
                            <td>{basic_information.contact_address?.postal_code}</td>
                        </tr>
                        <tr>
                            <th>{t('Telephone')}</th>
                            <td>{basic_information.contact_address?.telephone}</td>
                        </tr>
                        <tr>
                            <th>{t('Country')}</th>
                            <td>{basic_information.contact_address?.country}</td>
                        </tr>
                    </tbody>
                </Table>

                {/* Activity Classifications */}
                {activity_classifications?.length > 0 && (
                    <>
                        <h5 className="fw-bold font-size-16">{t('Activity Classifications')}</h5>
                        {activity_classifications.map((cls, idx) => (
                            <Card key={idx} className="mb-3">
                                <CardBody>
                                    <p><strong>{t('Classification')}:</strong> {cls.classification}</p>
                                    {cls.activities.map((act, i) => (
                                        <p key={i}>
                                            <strong>{t('Activity')}:</strong> {act.activity_description} ({act.activity_code})
                                        </p>
                                    ))}
                                </CardBody>
                            </Card>
                        ))}
                    </>
                )}
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default withNamespaces()(
    CompanyIdentification
)